import { render, staticRenderFns } from "./AvailabilitySlotPrice.vue?vue&type=template&id=4c47abe8&scoped=true&"
import script from "./AvailabilitySlotPrice.vue?vue&type=script&lang=js&"
export * from "./AvailabilitySlotPrice.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilitySlotPrice.vue?vue&type=style&index=0&id=4c47abe8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c47abe8",
  null
  
)

export default component.exports